<div class="wells-container" class="flex-column flex-fill">
  <kendo-tabstrip #wellsTabStrip [tabscroll]="false" [keepTabContent]="true" [animate]="false" class="flex-full flex-fill">
    <kendo-tabstrip-tab title="Teams" [selected]="true">
      <ng-template kendoTabContent>
        <app-project-team class="flex-100"></app-project-team>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Rigs">
      <ng-template kendoTabContent>
        <app-project-team-rigs class="flex-100"></app-project-team-rigs>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Frac Fleets">
      <ng-template kendoTabContent>
        <app-project-team-frac-fleets class="flex-100"></app-project-team-frac-fleets>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>